import axios from "axios";

if (!process.env.REACT_APP_API_URL) {
  console.error(
    "API URL missing. Please set REACT_APP_API_URL in your .env file."
  );
}

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 120000,
});

api.interceptors.request.use(
  (config) => {
    const isAdminContext = window.location.pathname.startsWith("/super-admin");
    const token = isAdminContext ? localStorage.getItem("adminToken") : localStorage.getItem("authToken");
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("userData");
      localStorage.removeItem("authToken");
      console.log("Session expired. Logging out...");
    }
    return Promise.reject(err);
  }
);

export default api;




// import axios from "axios";

// if (!process.env.REACT_APP_API_URL) {
//   console.error(
//     "API URL missing. Please set REACT_APP_API_URL in your .env file."
//   );
// }

// const api = axios.create({
//   baseURL: process.env.REACT_APP_API_URL,
//   withCredentials: true,
//   timeout: 120000,
// });

// // Interceptor to handle unauthorized (401) globally
// api.interceptors.response.use(
//   (res) => res,
//   (err) => {
//     if (err.response?.status === 401) {
//       localStorage.removeItem("userData");
//       console.log("Session expired. Logging out...");
//     }
//     return Promise.reject(err);
//   }
// );
// export default api;
